export default "__VITE_ASSET__hv9jHYgU__"